import { Injectable, inject } from '@angular/core';
import {
  collection,
  CollectionReference,
  Firestore,
} from '@angular/fire/firestore';
import { doc, getDoc } from '@angular/fire/firestore';
import { NotFoundError } from '../errors';

export interface AutocompleteChoice {
  id: string;
  label: string;
}

interface AutocompleteDoc {
  values: AutocompleteChoice[];
}

@Injectable({ providedIn: 'root' })
export class AutocompleteService {
  protected firestore = inject(Firestore);

  protected getCollection() {
    return collection(
      this.firestore,
      'autocomplete'
    ) as CollectionReference<AutocompleteDoc>;
  }

  protected getAutocompleteDoc(autocomplete: string) {
    return doc(this.getCollection(), autocomplete);
  }

  async getAutocompleteChoices(autocomplete: string) {
    const doc = await getDoc(this.getAutocompleteDoc(autocomplete));
    if (!doc.exists()) {
      throw new NotFoundError("Pas d'autocomplétion.");
    }
    return doc.data().values;
  }
}
